import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
import { DvsUtilities } from "src/app/dvs-utilities";
import { RoundListPipe } from "src/app/pipes";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { DvsChartComponent } from "src/app/shared/dvs-chart/dvs-chart.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-thresholding-cross",
	templateUrl: "./thresholding-cross.component.html",
	styleUrls: ["./thresholding-cross.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [FormsModule, ActionButtonComponent, DvsChartComponent, RoundListPipe]
})
export class ThresholdingCrossComponent implements OnInit {
	api = inject(ApiService);
	charting = inject(ChartingService);

	public assets: APIResults.Asset[];
	public multiAsset: APIResults.Asset[];
	public primaryAsset: APIResults.Asset;

	public queriedAssets: APIResults.Asset[];
	public thresholdError: string;
	public thresholdComponents: APIResults.ComponentThreshold[] = null;
	public selectedComponent: APIResults.ComponentThreshold;
	public boxPlotOptions: Highcharts.Options;
	public newConfig: string;

	async ngOnInit() {
		await this.RefreshAssets();
	}

	public async RefreshAssets() {
		let assets = await this.api.GetAllAssets();
		assets.sort((a, b) => a.organization_name.localeCompare(b.organization_name) || (a.fleet_name ?? "").localeCompare(b.fleet_name ?? "") || a.asset_name.localeCompare(b.asset_name));
		assets = assets.filter(asset => asset.organization_id !== 1 && asset.organization_id !== 8);
		this.assets = assets;
	}

	// Clear primaryAsset if no longer in selection
	async updatedSelection() {
		this.queriedAssets = undefined;
		this.thresholdComponents = undefined;
		this.thresholdError = undefined;
		this.selectedComponent = undefined;
		this.newConfig = undefined;
		if (!this.multiAsset.includes(this.primaryAsset)) {
			this.primaryAsset = null;
		}
	}

	public async UpdateThresholds() {
		this.queriedAssets = undefined;
		this.thresholdComponents = undefined;
		this.thresholdError = undefined;
		this.selectedComponent = undefined;
		this.newConfig = undefined;

		// Put the primary asset first in the list
		this.queriedAssets = [this.primaryAsset, ...this.multiAsset.filter(asset => asset.asset_id !== this.primaryAsset.asset_id)];
		try {
			const result = await this.api.GetThresholdCrossData(this.queriedAssets.map(item => item.asset_id));
			this.thresholdComponents = result.components;
			this.selectedComponent = this.thresholdComponents[0];
			this.UpdateComponent(this.thresholdComponents[0]);
			this.newConfig = result.xml;
		} catch (err) {
			this.thresholdError = DvsUtilities.GetRemoteErrorMessage(err, "Couldn't load threshold data");
		}
	}

	public async UpdateComponent(comp: APIResults.ComponentThreshold) {
		const categories = this.queriedAssets.map(item => item.asset_name);
		this.boxPlotOptions = this.charting.BoxPlotDefaults("Revised HI", categories, comp.stats, comp.outliers, "HI");
	}

	public async UploadConfig() {
		await this.api.UpdateConfig(this.queriedAssets[0].asset_type_id, this.newConfig);
	}
}
